<template>
  <div class="rate-and-suggest">
    <div class="layout">
      <back-button class="back-button" caption="ย้อนกลับ" />
    </div>

    <div class="wiv-body">
      <div class="psb-header">
        <img
          class="psbh-img"
          src="@/assets/images/email-success.png"
          alt="people-like"
        />
      </div>
      <div class="suscess-lable">สำเร็จ!</div>
      <div class="wivb-title">
        ขอบคุณสำหรับความคิดเห็นของคุณ
      </div>
      <div class="wivb-contents">
        <material-button class="psb-button" @clickButton="goBack">
          กลับไปหน้าแรก
        </material-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RateSuccess",
  props: ["prevPath"],
  components: {},
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>

<style scoped>
.rate-and-suggest {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.layout {
  width: 100%;
  padding: 0px 30px;
  max-width: 1120px;
  box-sizing: border-box;
}

.wiv-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 736px;
  text-align: center;
  position: relative;
  padding: 0px 30px;
  box-sizing: border-box;
}
.psb-header {
  margin-top: 14px;
  margin-bottom: 28px;
}
.psbh-img {
  width: 201px;
  height: 201px;
}
.wivb-back {
  color: #acb1bf;
  display: flex;
  align-items: center;
  margin-top: 23px;
  cursor: pointer;
  margin-bottom: 16px;
  width: 100%;
}
.wivbb-img-back {
  margin-right: 10px;
}
.wivb-title {
  width: 100%;
  display: flex;
  justify-content: center;
}
.wivb-contents {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 23px;
  font-size: 17px;
  margin-bottom: 24px;
}
.suscess-lable {
  font-weight: bold;
  font-size: 34px;
  color: #9bcc55;
}
.psb-button {
  width: 100%;
  max-width: 352px;
  text-align: center;
  margin-bottom: 14px;
}
.psb-button:hover {
  border: 1px solid #008fc1;
  background-color: #008fc1;
  font-weight: bold;
}
.psb-button:focus {
  outline: none;
}
.psb-button:disabled {
  border: 1px solid #d8d9e0;
  background-color: #d8d9e0;
  color: #b5b6bf;
  pointer-events: none;
  cursor: default;
}
.wivbn-link {
  cursor: pointer;
  color: #6db6f6;
}

.back-button {
  margin: 24px 0;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .layout {
    padding: 0 20px;
  }
  .back-button {
    margin-bottom: 0;
  }
}
</style>
